import { $color } from "@/utils/cssVarUtils"
import type {
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"


const baseStyle: SystemStyleFunction = (props) => {
  return {
    borderRadius: "0.333333em",
    bg: $color('bg-input-normal'),
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
    },
    _hover: {
      bg: $color('scene-primary-normal'),
      color: $color('dark-text-normal'),
      _disabled: {
        opacity: 0.4,
        bg: $color('bg-input-normal'),
        color: 'currentColor',
      }
    },
    _active: {
      bg: '',
    },
  }
}

const sizes: Record<string, SystemStyleObject> = {
  lg: {
    w: "5xl",
    h: '5xl',
    fontSize: 'md',
  },
  md: {
    w: "4xl",
    h: '4xl',
    fontSize: "sm",
  },
  sm: {
    w: "2xl",
    h: '2xl',
    fontSize: "0.625rem",
  },
  xs: {
    w: "md",
    h: 'md',
    fontSize: "2xs",
  },
}

const defaultProps = {
  size: "sm",
}

export const CloseButton = {
  baseStyle,
  sizes,
  defaultProps,
}